// 返回标准化题号
export const standardQuestionNumber = function (question) {
    return question.bigNum && question.smallNum ? question.bigNum + "." + question.smallNum : question.question + ''
}


// WEBPACK FOOTER //
// ./src/filter/index.js